import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTableTitleBoxBox = styled(Box)(({ theme }) => ({
  justifyContent: 'center',
  backgroundColor: 'white',
  borderTopRightRadius: '5px',
  borderTopLeftRadius: '5px',
  padding: '11px 30px',
  borderBottom: `3px solid ${theme.palette.primary.main}`,
  overflowX: 'auto',
  color: theme.palette.primary.main,
  fontSize: '25px',
  fontWeight: 'bold',
  minHeight: '75px',
  alignContent: 'center'
}));

const TableTitleBox = ({ title, sx = {}, ...props }) => {
  return (
    <StyledTableTitleBoxBox sx={sx} {...props}>
      {title}
    </StyledTableTitleBoxBox>
  );
};

export default TableTitleBox;
